import React from "react";
import { MessageCircle } from "lucide-react";
import { BRAND } from "../data/content";

const WhatsAppFloat = () => {
  const link = `https://wa.me/${BRAND.phoneDigits}?text=${encodeURIComponent(
    BRAND.whatsappMessage
  )}`;
  return (
    <a
      data-testid="whatsapp-float-btn"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-20 right-5 sm:bottom-6 sm:right-6 z-40 bg-[#25D366] text-white rounded-full shadow-lg shadow-emerald-700/30 hover:shadow-xl hover:scale-105 transition-all duration-300 flex items-center gap-2 px-4 py-3 font-semibold"
    >
      <MessageCircle className="w-5 h-5" strokeWidth={2.2} />
      <span className="hidden sm:inline text-sm">Chat with us</span>
    </a>
  );
};

export default WhatsAppFloat;
